// Pure model for company rental periods (FT-085, no `this`).
// Breakpoint semantics (REQ-02): boundaries = min + unique starts of saved
// periods within (min, max]; segment end = next boundary − 1; last goes to max.
// Gaps/overlaps are impossible by construction.

const PERIOD_RE = /^\s*(\d+)\s*-\s*(\d+)\s*$/;

// raw: array of "N - M" strings (or null). Returns { breakpoints, scaleEnd, normalized }.
// scaleEnd — конец последнего периода: обрезанный хвост (< max) легитимен,
// дни за ним движок считает без этой колонки. `normalized: true` — каноничная
// форма отличается от сохранённой: UI показывает плашку и не PATCH-ит молча.
export function parsePeriods(raw, min, max) {
  const pairs = [];
  if (Array.isArray(raw)) {
    raw.forEach((item) => {
      const m = PERIOD_RE.exec(String(item));
      if (m) pairs.push([parseInt(m[1], 10), parseInt(m[2], 10)]);
    });
  }
  const inRange = pairs.map(([s]) => s).filter((s) => s > min && s <= max);
  const breakpoints = [min, ...Array.from(new Set(inRange)).sort((a, b) => a - b)];
  const lastBp = breakpoints[breakpoints.length - 1];
  const lastPair = pairs.reduce((acc, p) => (acc === null || p[0] >= acc[0] ? p : acc), null);
  const scaleEnd = lastPair === null ? max : Math.min(Math.max(lastPair[1], lastBp), max);
  const normalized = !periodsEqual(raw, serializePeriods(breakpoints, scaleEnd));
  return { breakpoints, scaleEnd, normalized };
}

// breakpoints: sorted boundaries starting at min. Returns [{ from, to }, ...],
// последний сегмент — до scaleEnd (конца шкалы).
export function segmentsFromBreakpoints(breakpoints, scaleEnd) {
  return breakpoints.map((from, i) => ({
    from,
    to: i + 1 < breakpoints.length ? breakpoints[i + 1] - 1 : scaleEnd,
  }));
}

// Serializes back to the API format ["N - M", ...] (unchanged contract, CTR-01).
export function serializePeriods(breakpoints, scaleEnd) {
  return segmentsFromBreakpoints(breakpoints, scaleEnd).map((s) => `${s.from} - ${s.to}`);
}

function periodsEqual(raw, serialized) {
  if (!Array.isArray(raw) || raw.length !== serialized.length) return false;
  return raw.every((item, i) => String(item).trim() === serialized[i]);
}
